import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeEaState,
  searchCustomerInfo,
  saveEaJsonData,
  searchSignatureData,
  saveSignBothData,
  saveFpRealNameData,
} from '@store/actions/eaAction';
import EaHeader from '@components/ea/EaHeader';
import CustomerIdCheck from '@components/common/biz/CustomerIdCheck';
import OtherInfo from '@components/ea/OtherInfo';
import MediDiagnosisInfo from '@components/ea/MediDiagnosisInfo';
import EtcInfoSignPopup from '@components/ea/EtcInfoSignPopup';
import SuitabilityInfo from '@components/ea/SuitabilityInfo';
import UsdSuitabilityInfo from '@components/ea/UsdSuitabilityInfo';
import SatModal from '@components/common/satUI/SatModal';
import { isBeforeDate } from '@common/utils/validation';
import EaBottom from '@components/ea/EaBottom';

const OtherInfoCheck = props => {
  const {
    customer = {},
    applicationNo,
    currentPage,
    onClickPrev,
    onClickNext,
    isVariable,
    isUsdSuitability,
    suitabilityInfo,
    isPracticeMode = false,
    practiceSignName = '',
    practiceSignature = '',
  } = props;
  const {
    planMainInfo,
    contract,
    contractSign,
    realName = {},
    completePage = [],
    signData,
    completePdfPage,
    beneficiary,
    isMinor,
  } = useSelector(state => state.eaReducer);
  const dispatch = useDispatch();
  const [popupVisible, setPopupVisible] = useState(false); // 붙여넣기 체크 여부
  const [isDisabled, setIsDisabled] = useState(true);
  const [showErrorCheckMsg, setShowErrorCheckMsg] = useState(false);

  const handlerChangeEaState = requestData => {
    dispatch(changeEaState(requestData));

    if (completePage.includes(currentPage)) {
      // 완료된 페이지인 경우 완료상태 해제
      const completePages = completePage.filter(item => currentPage !== item);

      dispatch(
        changeEaState({
          type: 'completePage',
          data: [...new Set(completePages)],
        }),
      );
    }
  };

  const handlerOtherInfoChangeEaState = value => {
    // 기타정보1 바꿀시 개인용본인확인서 clear
    if (value.taxDutyYn) {
      const changeData = contractSign.map(data => {
        if (data.step === 526) {
          return {
            step: 526,
            q1: '',
            q2: '',
            q3: ['', ''],
            q4: ['', ''],
            q5: ['', ''],
            q6: ['', ''],
          };
        } else {
          return data;
        }
      });
      dispatch(changeEaState({ type: 'contractSign', data: changeData }));
      dispatch(
        changeEaState({
          type: 'completePdfPage',
          data: completePdfPage.filter(data => data === 1718),
        }),
      );
    }
    const requestData = {
      type: 'contract',
      data: {
        ...contract,
        etc: { ...contract.etc, ...value },
      },
    };
    handlerChangeEaState(requestData);
  };

  const handlerChangeContractSign = value => {
    const chagneContractSign = contractSign.map((data, index) => {
      if (index === 1) {
        return { step: 520, ...value };
      } else {
        return { ...data };
      }
    });
    const requestData = {
      type: 'contractSign',
      data: [...chagneContractSign],
    };
    handlerChangeEaState(requestData);
  };

  const searchCustomer = value => {
    dispatch(searchCustomerInfo(value));
  };

  const validationCheck = () => {
    let isDisabledNext = false;
    const isAuthCompleted = realName?.checkResult;

    // 실명증표확인
    if (!realName.afterCheckYn) isDisabledNext = !isAuthCompleted;

    // 기타정보확인
    // 해외 납세자 여부
    if (contract.etc.taxDutyYn === '') {
      isDisabledNext = true;
    }

    // 계약자 본인명의
    if (contract.etc.ownerYn === '') {
      isDisabledNext = true;
    } else if (contract.etc.ownerYn === 'N') {
      if (
        contract.etc.ownerRelate === '' ||
        contract.etc.domesticYn === '' ||
        contract.etc.ownerName === '' ||
        contract.etc.birthDay === '' ||
        contract.etc.birthDay.length < 6
      ) {
        isDisabledNext = true;
      }
    }

    // 승낙 거절사유 안내방법
    if (contractSign[1].q1 === '') {
      isDisabledNext = true;
    }

    setIsDisabled(isDisabledNext);
  };

  // 붙여넣기용 전자 서명 조회
  const handleSearchPasteSignData = () => {
    if (!signData.app_form_etc_18.app_form_etc_18_sign_02 && !isPracticeMode) {
      dispatch(
        searchSignatureData({
          applicationNo: applicationNo,
          signGubun: 'P',
          custNo: planMainInfo.ownerPrspInfo.custNo,
          reportId: 'app_form_etc_18',
        }),
      );
    }
  };

  // 개별 전자 서명 조회
  const handleSearchSignData = (reportId, signId, nameId) => {
    dispatch(
      searchSignatureData({
        applicationNo: applicationNo,
        signGubun: 'P',
        custNo: planMainInfo.ownerPrspInfo.custNo,
        reportId,
        nameId,
        signId,
      }),
    );
  };

  // 성명, 서명 서버 저장
  const handleSaveSignature = (
    signNameData,
    signatureData,
    reportId,
    signId,
    nameId,
  ) => {
    if (!isPracticeMode) {
      dispatch(
        saveSignBothData({
          applicationNo: applicationNo,
          signNameData: signNameData,
          signatureData: signatureData,
          signGubun: 'P',
          reportId,
          signId, // app_form_05_signId_02 - 이것만 signId 대문자
          nameId, // app_form_05_signId_01 - 이것만 signId 대문자
          callback: callbackSuccess,
        }),
      );

      // OZ 쪽에서 필요해 signId, nameId 소문자로도 저장
      // - 옴니에서는 소문자로만 저장한다고 함.
      // - 필요 시 소문자로 통일하는게 효율적으로 보이나, 기간이 많이 안남아 안전하게 둘 다 저장하는 것으로 선택
      dispatch(
        saveSignBothData({
          applicationNo: applicationNo,
          signNameData: signNameData,
          signatureData: signatureData,
          signGubun: 'P',
          reportId,
          signId: signId.toLowerCase(), // app_form_05_signId_02 => app_form_05_signid_02
          nameId: nameId.toLowerCase(), // app_form_05_signId_01 => app_form_05_signid_01
        }),
      );
    } else {
      dispatch(
        changeEaState({
          type: 'signData',
          data: {
            ...signData,
            app_form_05: {
              ...signData.app_form_05,
              app_form_05_signId_01: signNameData, // 기타정보확인 자필 성명
              app_form_05_signId_02: signatureData, // 기타정보확인 자필 서명
            },
          },
        }),
      );
      callbackSuccess(true);
    }
  };

  const handlerChangeFpReport = data => {
    const requestData = {
      type: 'realName',
      data: { ...realName, ...data },
    };
    handlerChangeEaState(requestData);
  };

  const callbackSuccess = type => {
    if (type) {
      setPopupVisible(false);
      const completePages = [...completePage, currentPage];
      dispatch(
        changeEaState({
          type: 'completePage',
          data: [...new Set(completePages)],
        }),
      );

      if (!isPracticeMode) {
        setTimeout(() => {
          // 기타정보 저장
          dispatch(saveEaJsonData({ applicationNo }));
          dispatch(saveFpRealNameData({ applicationNo }));
        }, 200);
      }

      onClickNext();
    }
  };

  const handleOnClick = async () => {
    // 하단 다음 버튼
    if (isDisabled) {
      setShowErrorCheckMsg(true);

      // 미입력항목 스크롤 이동 추가
      let resultData;
      if (!realName?.afterCheckYn) {
        if (realName?.certType === '2') {
          // 운전면허증
          if (
            realName?.licenseCode === '' ||
            realName?.licenseNumber?.length !== 10
          ) {
            resultData = true;
          }
        } else {
          // 주민증 or 외국인등록증
          if (
            realName?.authority === '' ||
            !isBeforeDate(realName?.issuedDate)
          ) {
            resultData = true;
          }
        }
      }

      if (resultData) {
        const targetY = document
          .getElementById('CustomerIdCheck')
          .getBoundingClientRect().top;

        const scrollWrapY = document
          .getElementById('otherinfoConWrap')
          .getBoundingClientRect().top; // 스크롤 영역의 y좌표

        const currentScrollTop =
          document.getElementById('otherinfoConWrap').scrollTop;

        const scrollToY = currentScrollTop + (targetY - scrollWrapY);
        document.getElementById('otherinfoConWrap').scrollTop = scrollToY;
      }
    } else {
      setPopupVisible(true);
    }
  };

  return (
    <React.Fragment>
      <EaHeader
        title={`2. 계약 정보 확인 및 작성 - 기타 정보 확인`}
        isFirstPage={false}
        onClickPrev={onClickPrev}
        onClickNext={onClickNext}
        isPracticeMode={isPracticeMode}
      />

      <div id="otherinfoConWrap" className="con-wrap bg-gray">
        <div className="app-wrap">
          {/* 외화적합성진단정보 */}
          {isUsdSuitability && (
            <UsdSuitabilityInfo
              suitabilityInfo={suitabilityInfo}
              isErrorMsg={
                suitabilityInfo.usdSuitabilityStatus === '3' ||
                suitabilityInfo.usdSuitabilityStatus === '4'
              }
            />
          )}

          {/* 변액적합성진단정보 */}
          {isVariable && (
            <SuitabilityInfo
              suitabilityInfo={suitabilityInfo}
              isErrorMsg={
                suitabilityInfo.suitabilityStatus === '3' ||
                suitabilityInfo.suitabilityStatus === '4'
              }
            />
          )}

          <CustomerIdCheck
            certifyBizKind="26"
            applicationNo={applicationNo}
            certType={realName?.certType}
            issuedDate={realName?.issuedDate}
            authority={realName?.authority}
            foreignAuthority={realName?.foreignAuthority}
            foreignIssuedDate={realName?.foreignIssuedDate}
            collateralNo={realName?.collateralNo}
            licenseNumber={realName?.licenseNumber}
            licenseCode={realName?.licenseCode}
            checkResult={realName?.checkResult}
            afterCheckYn={realName?.afterCheckYn}
            showErrorCheckMsg={showErrorCheckMsg}
            isMinor={isMinor}
            isVisibleForeigner={true}
            isVisibleAfterCheck={true}
            isVisibleSubTitle={false}
            isVisibleBottomExplanation={false}
            validationCheck={validationCheck}
            onChange={handlerChangeFpReport}
            onChangeMinor={handlerChangeFpReport}
          />

          {/* 기타 정보 */}
          <OtherInfo
            onChange={handlerOtherInfoChangeEaState}
            onChangeContractSign={handlerChangeContractSign}
            taxDutyYn={contract.etc.taxDutyYn}
            ownerRelate={contract.etc.ownerRelate}
            ownerYn={contract.etc.ownerYn}
            domesticYn={contract.etc.domesticYn}
            ownerName={contract.etc.ownerName}
            birthDay={contract.etc.birthDay}
            relationIndex={contract.etc.index}
            beneficiary={beneficiary}
            ownerPrspInfo={planMainInfo.ownerPrspInfo}
            searchCustomer={searchCustomer}
            rejectNotiWay={contractSign[1].q1}
            validationCheck={validationCheck}
            showErrorCheckMsg={showErrorCheckMsg}
          />

          {/* 건강진단 종류 */}
          {planMainInfo.medicalTypeText && (
            <MediDiagnosisInfo medicalTypeText={planMainInfo.medicalTypeText} />
          )}
        </div>
      </div>

      <EaBottom label="저장" isDisabled={isDisabled} onClick={handleOnClick} />

      <SatModal
        visible={popupVisible}
        setVisible={() => setPopupVisible(false)}
        type="info"
        wide
      >
        <EtcInfoSignPopup
          searchSignData={handleSearchSignData}
          searchPasteSignData={handleSearchPasteSignData}
          signPasteData={signData.app_form_etc_18}
          signData={signData.app_form_05}
          onSave={handleSaveSignature}
          complete={completePage.includes(currentPage)}
          ownerName={planMainInfo.ownerPrspInfo.name}
          isPracticeMode={isPracticeMode}
          practiceSignName={practiceSignName}
          practiceSignature={practiceSignature}
        />
      </SatModal>
    </React.Fragment>
  );
};

export default OtherInfoCheck;
